<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal-content">
      <h3>Editar Relato</h3>
      <form @submit.prevent="salvarEdicao">
        <!-- Ordem fixa dos campos para garantir consistência -->
        <div class="form-group">
          <label for="nome_cliente">{{ labels.nome_cliente }}</label>
          <input
            type="text"
            id="nome_cliente"
            v-model="relato.nome_cliente"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label for="cpf_cliente">{{ labels.cpf_cliente }}</label>
          <input
            type="text"
            id="cpf_cliente"
            v-model="relato.cpf_cliente"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label for="fone_cliente">{{ labels.fone_cliente }}</label>
          <input
            type="text"
            id="fone_cliente"
            v-model="relato.fone_cliente"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label for="placa_veiculo">{{ labels.placa_veiculo }}</label>
          <input
            type="text"
            id="placa_veiculo"
            v-model="relato.placa_veiculo"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label for="cep_veiculo">{{ labels.cep_veiculo }}</label>
          <input
            type="text"
            id="cep_veiculo"
            v-model="relato.cep_veiculo"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label for="motivo_contato">{{ labels.motivo_contato }}</label>
          <input
            type="text"
            id="motivo_contato"
            v-model="relato.motivo_contato"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label for="problema">{{ labels.problema }}</label>
          <input
            type="text"
            id="problema"
            v-model="relato.problema"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label for="relato_problema">{{ labels.relato_problema }}</label>
            <textarea
              id="relato_problema"
              v-model="relato.relato_problema"
              class="form-control textarea-auto-expand"
              rows="3"
            ></textarea>
          </div>

        <div class="form-group">
          <label for="atendente">{{ labels.atendente }}</label>
          <input
            type="text"
            id="atendente"
            v-model="relato.atendente"
            class="form-control"
            readonly
          />
        </div>

        <div class="form-group">
          <label for="protocolo">{{ labels.protocolo }}</label>
          <input
            type="text"
            id="protocolo"
            v-model="relato.protocolo"
            class="form-control"
          />
        </div>

        <div class="form-group">
          <label for="criado_em">{{ labels.criado_em }}</label>
          <input
            type="text"
            id="criado_em"
            v-model="relato.criado_em"
            class="form-control"
            readonly
          />
        </div>

        <button type="submit" class="save-button" :disabled="isLoading">
          Salvar
        </button>
        <button
          type="button"
          @click="fecharModal"
          class="cancel-button"
          :disabled="isLoading"
        >
          Cancelar
        </button>
      </form>
      <div v-if="isLoading" class="loading-overlay">
        <i class="fas fa-spinner fa-spin loading-icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    relatoData: {
      type: Object,
      required: true,
    },
    userName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      relato: {},
      isLoading: false,
      labels: {
        nome_cliente: "Nome do Cliente",
        cpf_cliente: "CPF do Cliente",
        fone_cliente: "Telefone do Cliente",
        placa_veiculo: "Placa do Veículo",
        cep_veiculo: "CEP do Veículo",
        motivo_contato: "Motivo do Contato",
        problema: "Problema",
        relato_problema: "Relato do Problema",
        atendente: "Atendente",
        protocolo: "Protocolo",
        criado_em: "Criado em",
      },
    };
  },
  methods: {
    async salvarEdicao() {
      this.isLoading = true;
      try {
        this.relato.atendente = this.userName; // Preenche o nome do usuário logado
        const response = await axios.put(
          `https://api-autoatendimento.nextcomm.tech/api/v1/relatos/${this.relato.id}`,
          //`http://127.0.0.1:19000/api/v1/relatos/${this.relato.id}`,
          this.relato
        );
        this.$emit("salvo", response.data);
        this.fecharModal();
      } catch (error) {
        console.error("Erro ao salvar o relato:", error);
      } finally {
        this.isLoading = false;
      }
    },
    fecharModal() {
      this.$emit("fechar");
    },
  },
  watch: {
    relatoData: {
      immediate: true,
      handler(newData) {
        this.relato = { ...newData };
        this.relato.atendente = this.userName; // Preenche o nome do usuário logado
      },
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-start; /* Alinha o modal no topo */
  padding-top: 5%; /* Adiciona espaço acima do modal */
  z-index: 1000; /* Modal com z-index alto */
}

.modal-content {
  background: white;
  padding: 20px;
  width: 90%;
  max-width: 900px;
  border-radius: 8px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 1001;
  max-height: 80vh; /* Limita a altura máxima do modal */
  overflow-y: auto; /* Adiciona rolagem se o conteúdo for muito longo */
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Overlay mais clara */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.loading-icon {
  font-size: 3rem;
  color: #008a36;
}

.form-group {
  margin-bottom: 10px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #008a36;
}

.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: none; /* 🔥 Evita que o usuário arraste manualmente */
  overflow-wrap: break-word; /* 🔥 Faz palavras longas quebrarem */
  word-wrap: break-word;
  white-space: pre-wrap; /* 🔥 Mantém espaços e quebra linhas */
}

.textarea-auto-expand {
  min-height: 60px; /* 🔥 Define um tamanho mínimo */
  max-height: 300px; /* 🔥 Limita para evitar que cresça demais */
  overflow-y: auto; /* 🔥 Adiciona scroll se for muito grande */
}

/* Estilo para input com sombra verde no foco */
.form-control:focus,
input:focus {
  box-shadow: 0 0 5px 2px #27471e;
  border-color: #00b044;
  color: #27471e;
}

.save-button {
  background-color: #27471e;
  color: white;
  padding: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-button {
  background-color: #ddd;
  color: black;
  padding: 10px;
  border: none;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
}

.save-button[disabled] {
  background-color: #8bc34a;
  cursor: not-allowed;
}

.save-button:hover:not([disabled]) {
  background-color: #00b044;
}

.cancel-button:hover {
  background-color: #bbb;
}
</style>